import "./tooltip.css"
import Tooltip from "./Tooltip"
import TooltipTrigger from "./TooltipTrigger"
import TooltipContent from "./TooltipContent"
import TooltipProvider from "./TooltipProvider"
import TooltipArrow from "./TooltipArrow"

export type { TooltipProps } from "./Tooltip"
export type { TooltipTriggerProps } from "./TooltipTrigger"
export type { TooltipContentProps } from "./TooltipContent"
export type { TooltipProviderProps } from "./TooltipProvider"

export default Object.assign(Tooltip, {
  Trigger: TooltipTrigger,
  Content: TooltipContent,
  Provider: TooltipProvider,
  Arrow: TooltipArrow,
})
